module.exports = __webpack_public_path__ + "static/media/VIP_EVENT.6a9a2aa3.svg";